import { type FC } from "react";

import { SmartLink } from "../../SmartLink.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

const BlastQueryCell: FC<IAgGridCellProps> = (props) => {
  const { value, data } = props;
  if (!data) {
    return null;
  }
  const { id, jobId } = data;

  return (
    <TableCell>
      <SmartLink to={`/job/${jobId}/results/${id}/summary`} tooltip={value}>
        {value}
      </SmartLink>
    </TableCell>
  );
};

export default BlastQueryCell;
